import { render } from "./PrimaryBenefits.vue?vue&type=template&id=6f1e763f"
import script from "./PrimaryBenefits.vue?vue&type=script&lang=js"
export * from "./PrimaryBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__